import { SxProps, Theme } from '@mui/material/styles';
import { secondaryContainerStyling } from '../../styles/sxStyling';

export const activityLogsStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: 1,
    p: 1,
  },
  logItem: {
    ...secondaryContainerStyling,
    border: '1px solid var(--border-light)',
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.6em',
    backgroundColor: 'background.paper',
    fontSize: '0.875rem',
  },
  description: {
    fontSize: '1em',
    fontWeight: 500,
  },
  meta: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#666',
    alignItems: 'center',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  user: {
    fontSize: '0.85em',
  },
  time: {
    fontSize: '0.8em',
    fontStyle: 'italic',
  },
  noLogsText: {
    fontSize: '0.85em',
    color: '#999',
    textAlign: 'center',
  },
};
